import { SurveyInterface } from '../../models/state';

export const actionTypes = {
  CREATE_EMAIL: 'CREATE_EMAIL',
  UPDATE_EMAIL: 'UPDATE_EMAIL',
  GET_EMAILS: 'GET_EMAILS',
  GET_EMAILS_SUCCESS: 'GET_EMAILS_SUCCESS',
  GET_EMAIL_BY_ID: 'GET_EMAIL_BY_ID',
  GET_EMAIL_BY_ID_SUCCESS: 'GET_EMAIL_BY_ID_SUCCESS',
  GET_EMAIL_BY_PARAMS: 'GET_EMAIL_BY_PARAMS',
  GET_EMAIL_BY_PARAMS_FAILURE: 'GET_EMAIL_BY_PARAMS_FAILURE',
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_TEST_EMAIL: 'SEND_TEST_EMAIL',
  RESET_EMAIL: 'RESET_EMAIL',
};

export const createEmail = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CREATE_EMAIL,
  payload: data,
  callback,
});

export const updateEmail = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.UPDATE_EMAIL,
  payload: data,
  callback,
});

export const getEmails = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.GET_EMAILS,
  payload: data,
  callback,
});

export const getEmailsSuccess = data => ({
  type: actionTypes.GET_EMAILS_SUCCESS,
  payload: data,
});

export const getEmailById = (id: string, callback = (_res: any, _message: string) => {}) => ({
  type: actionTypes.GET_EMAIL_BY_ID,
  callback,
  payload: id,
});

export const getEmailByIdSuccess = data => ({
  type: actionTypes.GET_EMAIL_BY_ID_SUCCESS,
  payload: data,
});

export const getEmailByParams = (
  data,
  callback = (_res: { id: string; surveyId: string; survey: SurveyInterface }) => {},
) => ({
  type: actionTypes.GET_EMAIL_BY_PARAMS,
  payload: data,
  callback,
});

export const sendEmail = (id: string, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.SEND_EMAIL,
  payload: id,
  callback,
});

export const sendTestEmail = (
  data: { email: string; content: string; subject: string },
  callback = (_res: boolean, _message: string) => {},
) => ({
  type: actionTypes.SEND_TEST_EMAIL,
  payload: data,
  callback,
});

export const resetEmail = () => ({
  type: actionTypes.RESET_EMAIL,
});
